<div id="commodityDoughnut" style="height: 230px; width: 100%"></div>
